/**
 * opora-d4-edge-bridge.js — wires D4 AI tool pages to gate + save + dashboard.
 * Expects: .opora-input-zone[data-tool], #opGenBtn, #opDocBody or #opResult
 */
(function () {
  'use strict';

  var EDGE = window.OporaEdge || {};
  var GATE = window.OporaGate;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }

  function ensureMeta(slug) {
    var m = qs('meta[name="opora:tool-slug"]');
    if (!m) {
      m = document.createElement('meta');
      m.setAttribute('name', 'opora:tool-slug');
      document.head.appendChild(m);
    }
    m.setAttribute('content', slug);
  }

  function revealPreviewZone() {
    var zone = qs('#d4PreviewZone');
    if (zone) zone.classList.add('is-live');
  }

  function outputHasResult(el) {
    if (!el) return false;
    var t = (el.textContent || '').trim();
    if (t.length < 40) return false;
    if (el.querySelector('.ot-output-inner, .ot-markdown-output, .d4-result-body, .result-body')) return true;
    if (el.querySelector('.ask-thinking, .skeleton, [aria-busy="true"]')) return false;
    return t.length > 80;
  }

  function normalizeResultFooter(panel) {
    if (!panel) return;
    var exports = panel.querySelectorAll('.opora-export-btn');
    if (exports.length && exports[0].parentElement) {
      exports[0].parentElement.classList.add('d4-export-row');
    }
  }

  function injectSaveBar(slug, anchor) {
    if (!anchor || qs('.opora-d4-save-bar', anchor.parentNode || anchor)) return;
    if (!window.OporaSave || typeof window.OporaSave.mountButton !== 'function') return;
    // When the unified action bar / Edge dock is active it provides Save,
    // so skip this legacy bar to avoid a duplicate, stale "sign in free".
    if (window.OporaActionBar) {
      if (typeof window.OporaActionBar.flagOn === 'function' && window.OporaActionBar.flagOn()) return;
      if (typeof window.OporaActionBar.isEdgeDockSlug === 'function' && window.OporaActionBar.isEdgeDockSlug(slug)) return;
    }

    var panel = anchor.closest('.d4-result-panel');
    var bar = document.createElement('div');
    bar.className = 'opora-d4-save-bar ot-save-bar';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Save output');

    var hint = document.createElement('p');
    hint.className = 'opora-d4-save-hint';
    hint.innerHTML = 'Save this output to your workspace — <button type="button" class="opora-d4-save-signin" style="background:none;border:none;padding:0;font:inherit;color:#0F7A70;font-weight:600;cursor:pointer;text-decoration:underline">sign in free</button> to keep it.';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'opora-save-btn ot-save-btn';
    btn.textContent = 'Save to library';

    bar.appendChild(hint);
    bar.appendChild(btn);
    var signInLink = hint.querySelector('.opora-d4-save-signin');
    if (signInLink) {
      signInLink.addEventListener('click', function (e) {
        e.preventDefault();
        if (EDGE.stashAuthReturn) EDGE.stashAuthReturn();
        /* Same as SOW Save: in-place popup; dashboard only if OporaAuth missing */
        if (window.OporaAuth && typeof window.OporaAuth.openModal === 'function') {
          window.OporaAuth.openModal({
            intent: 'sign-up',
            inPlace: true,
            title: 'Save this result',
            tagline: 'Create a free account to edit, duplicate, and access this result across devices.'
          });
          return;
        }
        var url = (EDGE.dashboardAuthUrl)
          ? EDGE.dashboardAuthUrl('sign-in')
          : 'https://dashboard.oporasupply.com/';
        window.location.href = url;
      });
    }
    anchor.parentNode.insertBefore(bar, anchor.nextSibling);
    normalizeResultFooter(panel);

    window.OporaSave.mountButton(btn, function () {
      var body = qs('#opDocBody') || qs('#opResult') || anchor;
      var inner = body.querySelector('.ot-markdown-output, .ot-output-inner') || body;
      var title = document.title.split('|')[0].trim() || slug;
      var inputs = {};
      document.querySelectorAll('.d4-f-input, .d4-f-select, textarea.d4-f-input').forEach(function (el) {
        if (el.name) inputs[el.name] = el.value;
      });
      return {
        title: title,
        content: inner.innerText || inner.textContent || '',
        body_markdown: inner.innerText || inner.textContent || '',
        input_payload: inputs
      };
    });
  }

  function wireD4() {
    var zone = qs('.opora-input-zone[data-tool]');
    if (!zone) return;

    var slug = zone.dataset.tool;
    if (!slug) return;

    ensureMeta(slug);

    var genBtn = qs('#opGenBtn');
    var genBtnConvo = qs('#opGenBtnConvo');
    var genBtns = [genBtn, genBtnConvo].filter(Boolean);
    var outEl = qs('#opDocBody') || qs('#opResult');
    var pendingRun = false;

    function resetOutputPipeline() {
      var out = qs('#opDocBody') || qs('#opResult');
      if (!out) return;
      out.removeAttribute('data-pipeline-id');
      out.removeAttribute('data-d4-bridge-done');
      var inner = out.querySelector('.ot-output-inner, .ot-markdown-output') || out;
      inner.removeAttribute('data-opora-wired');
      inner.removeAttribute('data-opora-wire-key');
      inner.removeAttribute('data-pipeline-id');
    }

    genBtns.forEach(function (btn) {
      btn.addEventListener('click', resetOutputPipeline, true);
    });

    if (genBtns.length && GATE && typeof GATE.guardSubmit === 'function' && !(EDGE.isQaUnlimited && EDGE.isQaUnlimited()) && !(EDGE.isAdminUnlimited && EDGE.isAdminUnlimited())) {
      genBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (!GATE.isSignedIn() && GATE.isCounted(slug)) {
            var runs = GATE.getToolRuns(slug);
            if (runs >= GATE.ANON_LIMIT) {
              e.preventDefault();
              e.stopImmediatePropagation();
              GATE.showHardModal(window.location.pathname);
              return false;
            }
            pendingRun = true;
          }
        }, true);
      });
    }

    if (outEl) {
      /* Gate + save bar only — never wire handoffs/spine here (DOM writes re-fire observer → hang). */
      var obs = new MutationObserver(function () {
        if (outEl.getAttribute('data-d4-bridge-done') === '1') return;
        if (!outputHasResult(outEl)) return;
        outEl.setAttribute('data-d4-bridge-done', '1');
        revealPreviewZone();
        if (pendingRun && GATE && !GATE.isSignedIn() && GATE.isCounted(slug)) {
          var qaOn = (EDGE.isQaUnlimited && EDGE.isQaUnlimited()) || (EDGE.isAdminUnlimited && EDGE.isAdminUnlimited());
          if (!qaOn) {
            var runs = GATE.getToolRuns(slug);
            if (runs < GATE.ANON_LIMIT) {
              GATE.setToolRuns(slug, runs + 1);
            }
            if (typeof GATE.applyPostRenderGate === 'function') {
              GATE.applyPostRenderGate(outEl, slug);
            }
          }
          pendingRun = false;
        }
        injectSaveBar(slug, outEl);
      });
      obs.observe(outEl, { childList: true, subtree: true });
    }
  }

  function init() {
    wireD4();
    applyD4RunBtnLabels();
    var labelAttempts = 0;
    var labelTimer = setInterval(function () {
      applyD4RunBtnLabels();
      labelAttempts++;
      if (labelAttempts >= 8) clearInterval(labelTimer);
    }, 300);
  }

  var D4_RUN_BTN_LABELS = {
    'margin-sentinel': 'Check my margin',
    'bid-drafter': 'Draft my bid',
    'bid-generator': 'Generate my bid',
    'rfp-decoder': 'Decode this RFP',
    'compliance-agent': 'Run compliance check',
    'hire-right': 'Build hiring package',
    'handbook-drafter': 'Draft my handbook',
    'customer-recovery': 'Build recovery plan',
    'lost-bid-autopsy': 'Run the autopsy',
    'review-response': 'Draft review response',
    'walkthrough-voice': 'Process walkthrough',
    'scope-of-work-generator': 'Build my scope',
    'production-rate-calculator': 'Calculate production rate',
    'bill-rate-calculator': 'Calculate bill rate',
    'dilution-calculator': 'Calculate dilution',
    'ppe-selector': 'Select PPE',
    'voc-compliance': 'Check VOC compliance'
  };

  function applyD4RunBtnLabels() {
    if (typeof window.oporaEnsureD4BtnLabels === 'function') {
      var zone = qs('.opora-input-zone[data-tool]');
      if (zone && zone.dataset.tool) {
        window.oporaEnsureD4BtnLabels(zone.dataset.tool);
        return;
      }
    }
    var slug = '';
    var zoneEl = qs('.opora-input-zone[data-tool]');
    if (zoneEl && zoneEl.dataset.tool) slug = zoneEl.dataset.tool;
    if (!slug) {
      var meta = qs('meta[name="opora:tool-slug"]');
      if (meta) slug = meta.content || '';
    }
    if (!slug) return;
    var label = D4_RUN_BTN_LABELS[slug] || 'Generate';
    qsa('.d4-btn-run').forEach(function (btn) {
      var lbl = btn.querySelector('.d4-btn-label');
      if (!lbl) {
        lbl = document.createElement('span');
        lbl.className = 'd4-btn-label';
        btn.insertBefore(lbl, btn.firstChild);
      }
      if (!String(lbl.textContent || '').trim()) lbl.textContent = label;
      if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', label);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
